import type * as React from 'react';

import { cn } from '../lib/utils';

// Exported so other components that aren't a plain `Input` can reuse the same resting/hover/
// focus/invalid look instead of restating it.
export const inputBaseClassName = cn(
    'placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground',
    'file:text-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
    'border-input flex h-10 w-full min-w-0 rounded-md border bg-input-background px-3 py-1',
    'text-base font-normal transition-[color,box-shadow] outline-none',
    'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
);
export const inputFocusClassName =
    'focus-visible:border-ring focus-visible:shadow-[0_0_0_2px_var(--color-accent)]';
export const inputInvalidClassName = 'aria-invalid:border-destructive';
export const inputInvalidFocusClassName = cn(
    'aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:shadow-[0_0_0_2px_color-mix(in_oklab,var(--color-destructive)_20%,transparent)]',
    'dark:aria-invalid:focus-visible:shadow-[0_0_0_2px_color-mix(in_oklab,var(--color-destructive)_40%,transparent)]',
);

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                inputBaseClassName,
                inputFocusClassName,
                inputInvalidClassName,
                inputInvalidFocusClassName,
                className,
            )}
            {...props}
        />
    );
}

export { Input };
